/* eslint-disable no-unused-vars */
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  initializeAuth, 
  browserLocalPersistence 
} from "firebase/auth";

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB_6p-B4fLET7DsU7ZXGBzmgM43TtjkyWg",
  authDomain: "eventplanly.firebaseapp.com",
  projectId: "eventplanly",
  storageBucket: "eventplanly.firebasestorage.app",
  messagingSenderId: "1086366693331",
  appId: "1:1086366693331:web:e8b7778d3edf7117e7e126",
  measurementId: "G-75BLY767JP"
};

// Initialize core app
const app = initializeApp(firebaseConfig);

// Auth setup (recaptcha-friendly, vercel-safe)
const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: undefined,
  experimentalForceLongPolling: true,
  useEmulator: false,
});

// Firestore
const db = getFirestore(app);

// Storage
const storage = getStorage(app);

// Export
export { auth, db, storage };
